import React from "react";
import { Button, Card, Row } from "reactstrap";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const PaymentInitial = (preps) => {
  const { trans } = preps;
  const { t } = useTranslation();

  return (
    <>
      <Card className='d-flex align-items-center justify-content-center flex-wrap'>
        <div className='mt-4 mb-4'>
          <h2>{t("payment_initial")}</h2>
        </div>
        <div className='mb-3'>{t("status-initial-text")}</div>
        <Row className='my-3'>
          <Link to={"/payment/" + trans}>
            <Button color='danger' size='sm' className='mt-4 mb-4'>
              {t("select-now")}
            </Button>
          </Link>
        </Row>
      </Card>
    </>
  );
};

export default PaymentInitial;
